module.exports = __webpack_public_path__ + "img/calf_principal.e6445f65.png";